export default {
    GET_ITEMS(state) {
        return state.artisans
    },
    GET_ITEMS_FULL_NAME(state) {
        return state.fullNameArtisans
    },
    GET_ITEMS_WITH_INTERVENTIONS(state) {
        return state.artisans_with_interventions
    },
}
